import { getAllListasPrecios } from "api";
import queryString from "query-string";
import { useEffect } from "react";
import { showErrorModal } from "utils";
import useQuery from "./useQuery";

const useGetListasPrecios = (seccionesId) => {
  const { data, refetch } = useQuery({
    autoFetch: false,
    queryFn: getAllListasPrecios,
    onError: (err) => showErrorModal({ err }),
  });

  const fetch = (seccionesId) => {
    const query = queryString.stringify({
      seccionesId
    });
    refetch(query);
  }

  useEffect(() => {
    if (!seccionesId) return;
    fetch(seccionesId);
  }, [seccionesId]);

  const listasPrecios = data?.data?.listas_precios;
  const listasPreciosOptions = listasPrecios?.map((item) => ({
    value: item.id,
    label: item.lista_precios,
    unidad_medida: {
      id: item.unidades_medidas_id,
      abreviatura: item.abreviatura,
    }
  }));

  return {
    listasPrecios,
    listasPreciosOptions,
    fetchListasPrecios: fetch,
  }
}

export default useGetListasPrecios;